import { HTMLProps } from "react"
import { Icon } from "./Icon"
import { Button } from "./Button"
import { Spinner } from "./Spinner"

export interface FileListItemProps {
  file: HTMLProps<File>
  state?: "loaded" | "loading-simple" | "loading-complex" | "error" | undefined
  progress?: number | undefined
  message?: string | undefined
  onDelete?: (name: string | undefined) => void
}

export const FileListItem = (props: FileListItemProps) => {
  const { file, onDelete, state, progress, message } = props

  const handleDelete = () => {
    onDelete!(file.name)
  }

  switch (state) {
    case "loading-simple":
      return (
        <li
          aria-busy="true"
          aria-live="polite"
          className="block-list__item file-list__item file-list__item--loading"
        >
          <div className="file-list__item__label">
            <Spinner className="file-list__item__icon" />
            {file.name}
          </div>
        </li>
      )

    case "loading-complex":
      return (
        <li
          aria-busy="true"
          aria-live="polite"
          className="block-list__item file-list__item file-list__item--loading"
        >
          <div className="file-list__item__label">{file.name}</div>
          <div
            role="progressbar"
            aria-valuemax={100}
            aria-valuemin={0}
            aria-valuenow={progress}
            className="file-list__item__meta progressbar"
          >
            <span className="progressbar__label">{progress}%</span>
            <div role="presentation" className="progressbar__background">
              <div
                className="progressbar__fill"
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>
        </li>
      )

    case "error":
      return (
        <li className="block-list__item file-list__item file-list__item--error">
          <div className="message message--problem">
            <div className="file-list__item__label">
              <Icon name="alert_triangle" className="file-list__item__icon" />
              {file.name}
              <Button
                iconRight="x"
                variant="text-inverted"
                size="small"
                className="file-list__item__button"
                onClick={handleDelete}
              />
            </div>
            <p className="file-list__item__meta">{message}</p>
          </div>
        </li>
      )

    default: {
      const loaded = state === "loaded"
      return (
        <li
          aria-busy={loaded ? false : undefined}
          aria-live={loaded ? "polite" : undefined}
          className="block-list__item file-list__item file-list__item--default"
        >
          <div className="file-list__item__label">
            {loaded && <Icon name="check" className="file-list__item__icon" />}
            {file.name}

            <Button
              iconRight="trash"
              variant="text"
              size="small"
              className="file-list__item__button"
              onClick={handleDelete}
            />
          </div>
        </li>
      )
    }
  }
}
